"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnstakeResponseBody = exports.UnstakeRequestBody = void 0;
/**
 * Class representing the request body for unstaking tokens.
 * Implements {@link IUnstakeRequestBody}.
 */
class UnstakeRequestBody {
    /**
     * Constructs a new instance of the UnstakeRequestBody class.
     * @param params - The {@link IUnstakeRequestBody} parameters for unstaking.
     */
    constructor({ accountAddress, tokenAmount, tokenAddress }) {
        this.accountAddress = accountAddress;
        this.tokenAmount = tokenAmount;
        this.tokenAddress = tokenAddress;
    }
    /**
     * Creates a new instance of the UnstakeRequestBody class from a JSON object.
     * @param json - The JSON object representing the UnstakeRequestBody.
     * @returns A new instance of the UnstakeRequestBody class.
     */
    static fromJson(json) {
        return new UnstakeRequestBody(json);
    }
    /**
     * Converts the UnstakeRequestBody instance to a JSON object.
     * @returns The JSON representation of the UnstakeRequestBody instance.
     */
    toJson() {
        return {
            accountAddress: this.accountAddress,
            tokenAmount: this.tokenAmount,
            tokenAddress: this.tokenAddress,
        };
    }
}
exports.UnstakeRequestBody = UnstakeRequestBody;
/**
 * Class representing the response body for an unstake operation.
 * Implements {@link IUnstakeResponseBody}.
 */
class UnstakeResponseBody {
    /**
     * Constructs a new instance of the UnstakeResponseBody class.
     * @param params - The {@link IUnstakeResponseBody} parameters for the response body.
     */
    constructor({ contractAddress, encodedABI }) {
        this.contractAddress = contractAddress;
        this.encodedABI = encodedABI;
    }
    /**
     * Creates a new UnstakeResponseBody instance from a JSON object.
     * @param json - The JSON object representing the UnstakeResponseBody.
     * @returns A new UnstakeResponseBody instance.
     */
    static fromJson(json) {
        return new UnstakeResponseBody(json);
    }
    /**
     * Converts the UnstakeResponseBody instance to a JSON object.
     * @returns The JSON object representing the UnstakeResponseBody.
     */
    toJson() {
        return {
            contractAddress: this.contractAddress,
            encodedABI: this.encodedABI,
        };
    }
}
exports.UnstakeResponseBody = UnstakeResponseBody;
